export const normalizeInnDigits = (value: string): string => value.replace(/\D/g, '')

/** Counterparty INN from price lists may be a legal entity (10) or an individual entrepreneur (12). */
export const isValidInn = (value: string): boolean => {
  const digits = normalizeInnDigits(value)
  return digits.length === 10 || digits.length === 12
}

/** Client's own identity: legal-entity INN only. */
export const isValidLegalEntityInn = (value: string): boolean => normalizeInnDigits(value).length === 10

export const innValidationMessage = (value: string): string | null => {
  const trimmed = value.trim()
  if (!trimmed) {
    return 'Укажите ИНН поставщика.'
  }
  if (!isValidInn(trimmed)) {
    return 'ИНН должен содержать 10 или 12 цифр.'
  }
  return null
}

export const legalEntityInnValidationMessage = (value: string): string | null => {
  const trimmed = value.trim()
  if (!trimmed) {
    return 'Укажите ИНН юридического лица.'
  }
  if (!isValidLegalEntityInn(trimmed)) {
    return 'ИНН юридического лица должен содержать 10 цифр.'
  }
  return null
}
